// extracted by mini-css-extract-plugin
export default {"spinnerPadding":"style_spinnerPadding__wC-M-","container":"style_container__tNM92","icon":"style_icon__37BuB","header":"style_header__t2K-r","button":"style_button__YYRpy"};